
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const appInsights = new ApplicationInsights({
    // https://learn.microsoft.com/es-es/azure/azure-monitor/app/javascript-sdk-configuration
    config: {
      instrumentationKey: config.public.applicationInsightsInstrumentationKey,
      enableAutoRouteTracking: true, // Habilita el seguimiento automático de rutas,
      disableAjaxTracking: true, // Desactiva el rastreo automático de solicitudes AJAX/Fetch
      disableFetchTracking: true, // Desactiva el rastreo automático de solicitudes Fetch
      disableCorrelationHeaders: true, // Desactiva la adición automática de encabezados de correlación
      disableTelemetry: false, // Puedes desactivar completamente el envío de telemetría si lo deseas
      autoTrackPageVisitTime: false, // Desactiva el seguimiento automático del tiempo de las página
      
    },
  });

  appInsights.loadAppInsights();

  // Inyectar la instancia de Application Insights al contexto de Nuxt
  nuxtApp.provide('appInsights', appInsights);
});
